<template>
  <div class='EnbProdImg'>
    <img v-if="data.img.length" :src="api + data.img[0].img" @click="Select">
    <div class="cont-img-icon">
      <img-icon
      :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
      v-if="!data.img.length"
      @click="Select"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbProdImg',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(() => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    }
  }
}
</script>

<style scoped>
.EnbProdImg {
  width: 100%;
  height: 250px;
}

img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.cont-img-icon {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
